import React from "react";
import Landing from "../components/Landing";
import Projects from "../components/Projects";
import Services from "../components/Services";
import Contact from "../components/Contact";

const Main = () => {
    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        // alert(sectionId)
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

    return (
        <>
        <Landing id='Home' onNavClick={scrollToSection}/>
        <Projects id='About'/>
        <Services id='Services'/>
        <Contact id='Contact Us'/>
        <Contact id='Subscribe'/>
              {/* <Footer/> */}
        </>

    )
}

export default Main;
